//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    days: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      rand: 0
    }
  },
  created () {
    this.rand = Math.round(Math.random())
    console.log('random', this.rand)
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
